<div style="margin-left:28px;"class="span6 alignmentContainerId centerCorrelation">
	<span>By Alignment:</span>
	<div class="alignmentcheckboxdiv">
		 <input type="checkbox" class=""  [(ngModel)]="correlationService.printAllign"><label style="font-size: small;" class="chkboxlbl">PRINT</label>
	 </div>
	 <div class="alignmentcheckboxdiv">
		 <input type="checkbox"  class="" [(ngModel)]="correlationService.degitialAllign"><label style="font-size: small;" class="chkboxlbl">DIGITAL</label>
	 </div>	
	 <!-- value1 = {{reportAlignmentType.value1}}	 -->		 					 	
</div>